import { render } from "./promotions-slim.vue?vue&type=template&id=91402922&scoped=true"
import script from "./promotions-slim.vue?vue&type=script&lang=js"
export * from "./promotions-slim.vue?vue&type=script&lang=js"

import "./promotions-slim.vue?vue&type=style&index=0&id=91402922&scoped=true&lang=css"

import exportComponent from "C:\\Users\\daniel.montano\\Desktop\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91402922"]])

export default __exports__